import requirementsStore from './requirements-store';
import loginStore from './login-store';

export default [requirementsStore, loginStore];
